import { hiddenNavigationList, layoutPublicUrl, publicUrlapi } from './../constants/index';
import { RouteComponentProps } from 'react-router-dom';
import { APPList, cusAppModules, mainClsPrefix, MAPPList, MInnerAPPList } from '../constants';
import { headerMenuStore } from "../components/main/navigation/store";
import { Dialog, MenuItemData } from "@weapp/ui";
import mainStore from "../components/main/store";
import { dayjs, getLabel, setTitle, ua } from '@weapp/utils';
import { toJS } from 'mobx';
import { LayoutSDK } from '../lib';
import { LayoutMenuSDKParamsProps } from './sdk';
import { clientTypeLayoutModeMap, LayoutModes, searchLocationMap, SearchShowType } from "../components/main/types";
import { IconShowType } from "../components/main/navigation/widgets/quickToolbar/types";
import { parse } from "qs";
import externalThemeBgH from "../assets/external-theme-bg-h.png";
import externalThemeBgV from "../assets/external-theme-bg-v.png";

/**
 * @created : 2021/3/23
 * @author  : 王冲
 * @desc    : 常用工具
 */

//统一处理手机号格式
export const mobileReg = /^[0-9]{7,11}$/;
export const mobileLocalReg = /^((13|14|15|17|18|19|16)[0-9]{9})|((\\+|)8869[0-9]{8})|((\\+|)852[569][0-9]{7})|((\\+|)1[2-9][0-9]{2}[2-9][0-9]{6})|((\\+|)84((1(2([0-9])|6([2-9])|88|99))|(9[0-9]{2}))[0-9]{7})|((\\+|)855[0-9]{8})|((\\+|)65[0-9]{8})$/;

// const ua = window.navigator.userAgent;
const userName = window.TEAMS?.currentUser?.username;
/*
* 单级路由组件，可以动态挂在任何一级路由下
* 需要获取父级路由
*/
export function fomatParentPath(props: RouteComponentProps) {
	return props.match.url.replace(/\/$/, () => '');
}
/*
* 获取cookie
*/
export function getCookie(name: string) {
	let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	arr = document.cookie.match(reg);
	if (arr)
		return unescape(arr[2]);
	else
		return null;
}

/*
* 设置cookie
*/
export function setCookie(name: string, value: any) {
	document.cookie = `${name}=${value};path=/;`;
	console.log(userName)
}

export function setPomCookie(name: string, value: string, domain?: string) {
	if (!domain) {
		domain = window.location.hostname;
	}
	document.cookie = `${name}=${value};domain=${domain};path=/;`;
}

/*
* 根据条件分割数组
*/
export function cutArr(arr: any[], condition: () => void) {
	arr = arr.concat([]);
	let result: any = [];
	function getCuts() {
		let idx = arr.findIndex(condition);
		if (idx !== -1) {
			result.push(arr.splice(0, idx));
			arr.shift();
			getCuts();
		} else {
			result.push(arr)
		}
	}
	getCuts();
	return result;
}

/*
* 操作系统
*/
export function currentOS() {
	return /macintosh/i.test(window.navigator.userAgent) ? 'mac' : 'win';
}

/*
* 是否为高清屏
*/
export function isRetina() {
	return window.devicePixelRatio && window.devicePixelRatio > 1;
}

export function isMobile() {
	return ua.device === 'Mobile' || window.location.pathname.replace(layoutPublicUrl, '').indexOf("/mobile") === 0;
}
export function isIos() {
	return /(iPhone|iPad|iPod)/i.test(navigator.userAgent)
}
export function isMobileUrl() {
	return window.location.pathname.replace(layoutPublicUrl, '').indexOf("/mobile") === 0;
}
export function isMobileUa() {
	return ua.device !== 'PC';
}
const colors = [
	"#1cb1e7", "#f9a900", "#ffc32e", "#1cb1e7", "#f75e8d", "#5ec9f7", "#ff8f6a", "#3ac3b5", "#78c16e", "#ff953d",
	"#78c16c", "#9b89b9", "#78919d", "#5c6ac1", "#5e97f7", "#f75e8c", "#ff8f6a", "#3ac3b5", "#9b89b9", "#ff8f6a",
	"#a1897e", "#ff8f6a", "#9b89b9", "#f75e8d", "#a1897e", "#ff953d", "#78c16e", "#3ac3b5", "#a1897e", "#bd85cd",
	"#5ec9f7", "#f75e5e", "#f7bf26", "#5c6ac1", "#f7bf26", "#bd85cd", "#f75e5e", "#78919d", "#5ec9f7", "#78c16e",
	"#f36666", "#ff608f", "#7066e3", "#ff784a", "#1acf8d", "#4693f9", "#81d12c", "#7066e3", "#b774d3", "#81d12c",
	"#7066e3", "#ff784a", "#00c3eb", "#ff9702", "#3497f1", "#81d12c", "#ff9700", "#00c3eb", "#1acf8d", "#f96a6a",
	"#81d12c", "#b774d3", "#ff608f", "#ff5e32", "#df3030", "#df3058", "#46addd", "#5874bf", "#5ec956", "#f15e4a"
];

export function getRandomColorByData(current: any, allData: any) {
	let currentId = 0;
	let newArray: any = [];
	if (current && allData.length) {
		allData.forEach((item: any) => {
			newArray = newArray.concat([...(item.menus || [])])
		})
		currentId = newArray.findIndex((it: any) => it.id === current.id)
	}
	return colors[currentId % (colors.length)];
}

export function getRandomColor() {
	return colors[Math.floor(Math.random() * colors.length)]
}
export function getFixedColor(sn: number) {
	return colors[sn]
}
export function checkMobileModuleInfo(pathname: string) {

	let info: any = {}
	if (pathname === '/') {
		info.moduleType = 'index';
	} else {
		if (pathname.indexOf('/mobile/') != -1) {
			const targetName = pathname.split('/')[2];
			info.moduleName = targetName;
			if (MAPPList.includes(targetName))
				info.moduleType = 'cros';
			else if (MInnerAPPList.includes(targetName))
				info.moduleType = 'inner';
			else
				info.moduleType = '404';

		} else {
			info.moduleType = '404';
		}
	}
	return info;
}
export function checkPCModuleInfo(pathname: string) {

	let info: any = {}
	if (pathname === '/') {
		info.moduleType = 'index';
	} else {
		const targetName = pathname.split('/')[1];
		info.moduleName = targetName;
		if (APPList.includes(targetName))
			info.moduleType = 'cros';
		else
			info.moduleType = '404';
	}
	return info;
}
export function sortBy(keyName: string) {
	return function (objectN: any, objectM: any) {
		let valueN = Number(objectN[keyName]);
		let valueM = Number(objectM[keyName]);
		if (valueN > valueM) return 1;
		else if (valueN < valueM) return -1;
		else return 0;
	};
}
export function needLayout() {
	return window.location.pathname.indexOf("/splayout") > -1;
}
export function mainHost() {
	let host = window.location.protocol + '//' + window.location.host;
	if (host.indexOf('localhost') !== -1 || host.indexOf('develop.cn') !== -1) {
		host = "http://weapp.develop.cn"
	}
	return host;
}
export function clearTeamsCookie() {
	window.ePassport?.clearCookies();
	clearCookieByName('ETEAMSID');
	clearCookieByName('WECHAT_ETEAMSID');
}
export function clearH5LoginCookie() {
	let host = window.location.hostname;
	host = host.substr(host.indexOf('.') + 1);
	document.cookie = "e_h5_login_auto=;domain=." + host + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	var newhost = host.substr(host.indexOf('.') + 1);
	document.cookie = "e_h5_login_auto=;domain=." + newhost + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
export function clearPCLoginCookie() {
	let host = window.location.hostname;
	host = host.substr(host.indexOf('.') + 1);
	document.cookie = "e_pc_login_auto=;domain=." + host + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	var newhost = host.substr(host.indexOf('.') + 1);
	document.cookie = "e_pc_login_auto=;domain=." + newhost + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export const controlGroupData = (data: any[]) => {
	let newArray: any = [];
	data.forEach(it => {
		if (!newArray[it.line - 1] || newArray[it.line - 1].length === 0) {
			newArray[it.line - 1] = []
		}
		newArray[it.line - 1].push(it)
	})

	return newArray.filter((it: any) => it);
}
// 私有环境
export function isPrivateEnv() {
	return window.TEAMS?.deploy === 'private';
}
// 单租户
export function isSingleTenant() {
	if (localStorage.getItem("TEST_SINGLE_TENANT")) {
		return true;
	}
	return window.TEAMS?.tenantType === 'single';
}
export function canCreateTeams() {
	if (isE10Self()) {
		return false;
	}
	if (window.weappTenantEnv?.createTenant === 'false') {
		return false;
	}
	if (window.weappTenantEnv?.onlyMainTenantCreate === 'on') {
		return isManagerTenant() && window.TEAMS?.currentUser?.admin;
	}
	return !isSingleTenant();
}
// APP客户端
export function inApp() {
	// alert(navigator.userAgent);
	return /weapp/i.test(navigator.userAgent);
}
// 企业微信
export function inWxWork() {
	return /wxwork/i.test(navigator.userAgent);
}

//是否正式环境
export const isProductEnv = () => {
	return window.TEAMS.runMode === 'txproduction' && window.TEAMS?.deploy === "public";
}

//是否是beta或者正式环境
export const isProOrBetaEnv = () => {
	return (window.TEAMS.runMode === 'beta' || window.TEAMS.runMode === 'txproduction') && (window.TEAMS?.deploy === "public")
}

//是否走cusapp渲染
export function checkCusApp() {
	//publicurl需替换
	let flag = false,
		pathname = window.location.pathname.replace(layoutPublicUrl, '').replace('/splayout', '');
	let pathArr = pathname.split('/'),
		targetModuleName = pathArr[1];
	for (let i = 0; i < cusAppModules.length; i++) {
		if (cusAppModules[i].indexOf('/') !== -1) {
			if (pathname.indexOf(cusAppModules[i]) === 0) {
				flag = true;
				break;
			}
		} else {
			if (cusAppModules[i] === targetModuleName) {
				flag = true;
				break;
			}
		}
	}
	return flag;
}
/*菜单更新sdk处理 */
export const updateMenuInfoData = (key: string, value: any) => {
	const list = ['asideMenusData',//左侧菜单
		'asideMenuActiveKey',//左侧高亮菜单
		'asideMenuExpandKeys',//侧边展开的菜单id
	]
	if (list.includes(key) && (checkCusApp() || window.location.pathname.indexOf('/free') === 0 || window.location.pathname.indexOf('/cusapp') === 0)) return;
	LayoutSDK.setDataByKey({
		key,
		value,
		source: 'layout'
	} as LayoutMenuSDKParamsProps);
}
//根据路由获取模块名称
export const getModuleName = () => {
	let locationPath = window.location.pathname.replace(layoutPublicUrl, '');
	locationPath = locationPath.replace(/^\/(splayout|sp|mobile)/, '');
	let moduleName = locationPath.split('/')[1];
	if (moduleName === 'workflows') {
		moduleName = 'workflow';
	} else if (moduleName === 'free') {
		moduleName = 'cusapp';
	}
	if (checkCusApp()) {
		moduleName = 'cusapp';
	}
	// 路由非法，默认跳转到首个模块
	return APPList.length && APPList.includes(moduleName) ? moduleName : undefined;
}

//是否是cusapp相关模块
export const isCusapp = () => {
	return ((checkCusApp() || getModuleName() === 'cusapp'));
}

//混合菜单转换树形数据
export const mapCategoryTreeToTreeData = (categoryTree: any, parentPath: string): MenuItemData & { extraData: any } | any => {
	if (!categoryTree) return {};
	const treeNode: MenuItemData & { originData: any } = {
		id: categoryTree?.id || '',
		// title: categoryTree.name,
		content: categoryTree?.showName,
		icon: categoryTree?.icon,
		originData: { ...categoryTree, parentPath: parentPath },
	};
	if (categoryTree.children) {
		treeNode.children = categoryTree.children.map((child: any) => mapCategoryTreeToTreeData(child, parentPath));
	}
	return treeNode;
};


// em登出
export function emLogout() {
	if (inApp()) {
		try {
			window.weappEm?.mainWeappIsLogout?.();
		} catch (error) {
			console.error(error);
		}
	}
}
// 第三方客户端
export function inThirdApp() {
	let flag = false;
	if (/wxwork|dingtalk|taurusapp|lark|qing|cloudlink|welink/i.test(navigator.userAgent)
		&& window.TEAMS
		&& window.TEAMS.loginChannel
		&& window.TEAMS.loginChannel.indexOf('ebridge_') !== -1) {
		flag = true;
	}
	return flag
}
// 第三方客户端
export function isThirdAppUa() {
	return /wxwork|dingtalk|taurusapp|lark|qing|cloudlink|welink/i.test(navigator.userAgent)
}

const regexs: any = {
	'validation.ip': /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/,
	'validation.ipv4': /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
	'validation.ipv6': /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/,
	'validation.telephone': /(^(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})-(\d{1,4})$)|(^(\d{7,8})-(\d{1,4})$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/,
	'validation.pattenChinese': /^([\u2e80-\u9fffa-zA-Z()（） ]+){2,40}$/,
	'validation.name': /^([\u2e80-\u9fff a-zA-Z]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
	'validation.username': /^([\u2e80-\u9fff a-zA-Z()（）]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
	'validation.usernameloose': /^([\u2e80-\u9fff a-zA-Z0-9()（）_-]+){1,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
	'validation.company': /^([\u2e80-\u9fff]+){2,}$|^([a-zA-Z]+[\s.]?){0,}[a-zA-Z]+$/,
	'validation.teamName': /^[\u4e00-\u9fa5aa-zA-Z()（） ]+$/,
	'validation.email': /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
	'addteamview.addTeam': /^[\u4e00-\u9fa5aa-zA-Z()（） ]+$/,
	// 'formPlugin.sensitiveWords' : /中[^\u4e00-\u9fa5]*奖|支[^\u4e00-\u9fvalidation.emaila5]*付[^\u4e00-\u9fa5]*宝|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*卡|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*[账帐][^\u4e00-\u9fa5]*户|网[^\u4e00-\u9fa5]*银|银[^\u4e00-\u9fa5]*行[^\u4e00-\u9fa5]*[账帐][^\u4e00-\u9fa5]*号/g,
	'formPlugin.sensitiveWords.html': /中((?!><)[^\u4e00-\u9fa5])*奖|支((?!><)[^\u4e00-\u9fa5])*付((?!><)[^\u4e00-\u9fa5])*宝|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*卡|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*[账帐]((?!><)[^\u4e00-\u9fa5])*户|网((?!><)[^\u4e00-\u9fa5])*银|银((?!><)[^\u4e00-\u9fa5])*行((?!><)[^\u4e00-\u9fa5])*[账帐]((?!><)[^\u4e00-\u9fa5])*号/g,
	'formPlugin.sensitiveWords.json': /中((?!"},{")[^\u4e00-\u9fa5])*奖|支((?!"},{")[^\u4e00-\u9fa5])*付((?!"},{")[^\u4e00-\u9fa5])*宝|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*卡|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*[账帐]((?!"},{")[^\u4e00-\u9fa5])*户|网((?!"},{")[^\u4e00-\u9fa5])*银|银((?!"},{")[^\u4e00-\u9fa5])*行((?!"},{")[^\u4e00-\u9fa5])*[账帐]((?!"},{")[^\u4e00-\u9fa5])*号/g,
	'crm.validation.name': /^([\u2e80-\u9fff]+){2,}$|^([a-zA-Z]+[\s.]?){0,4}[a-zA-Z]+$/,
	'crm.validation.chinese': /.*[\u4e00-\u9fa5]+.*$/,
	'sender.writeletterview.address': /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
	'emoji.h5.filter': /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
	'im.chat.send.emoji.filter': ['\ud83c[\udf00-\udfff]', '\ud83d[\udc00-\ude4f]', '\ud83d[\ude80-\udeff]'],
	'wechat.convert.cn': new RegExp(/.*[\u4e00-\u9fa5]+.*$/),
	'freeform.textregulareditor.chinese': /^[\u4E00-\u9FA5]+$/,
	'freeform.textregulareditor.number': /^[0-9]+$/,
	'freeform.textregulareditor.letter': /^[A-Za-z]+$/,
	'freeform.textregulareditor.lettersNumbers': /^[A-Za-z0-9]+$/,
	'freeform.textregulareditor.mobile': /^1[3-9]\d{9}$/,
	'freeform.textregulareditor.phone': /(^(\d{7,8})$)|(^\((\d{3,4})\)(\d{7,8})$)|(^(\d{3,4})-(\d{7,8})$)|(^(\d{3,4})(\d{7,8})$)|(^(\d{3,4})(\d{7,8})-(\d{1,4})$)|(^(\d{3,4})-(\d{7,8})-(\d{1,4})$)|(^\((\d{3,4})\)(\d{7,8})-(\d{1,4})$)|(^(\d{7,8})-(\d{1,4})$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/,
	'freeform.textregulareditor.email': /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
	'freeform.textregulareditor.idcard': /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
	'freeform.textregulareditor.postcode': /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/,
	'freeform.textregulareditor.minlength': /^.{10,}$/,
	'freeform.textregulareditor.maxlength': /^.{0,200}$/,
	'freeform.textregulareditor.lengthRange': /^.{10,200}$/
}
export function specialRegex(type: string, value: string) {
	return regexs[type].test(value)
}

// eslint-disable-next-line

export function setTheme(theme?: any) {
	if (!theme) {
		theme = window.TEAMS?.theme || {};
		//预览
		try {
			if (window.parent?.previewThemeData) {
				theme = window.parent?.previewThemeData;
				// 公共--主按钮色
				if (theme.primaryColor) {
					document.documentElement.style.setProperty('--primary', theme.primaryColor);
					if (theme?.primaryColor && window.TEAMS?.theme?.primaryColor) {
						window.TEAMS.theme.primaryColor = theme.primaryColor;
					}
				}
			}
		} catch (e) {

		}
	}

	// 导航--添加风格区分标识
	const themeParentNode: any = document.querySelector(`.${mainClsPrefix}-layout`);

	//浏览器窗口标题
	// if (theme.titleName) {
	setTitle({
		title: window.weappLayout?.layoutTitle || getBrowserTitle(null, theme)
	})
	// }

	if (theme.topicStyle) {
		//调整右上角logo显示顺序
		headerMenuStore.exchangeTenantLogo(theme.topicStyle, theme.toolIcoColor);
		// 标记当前风格样式
		// const themeParentNode: any = document.querySelector(`.${mainClsPrefix}-layout`);
		themeParentNode.setAttribute('ui-theme', `${theme.topicStyle}${theme.topicType ? `-${theme.topicType}` : ''}`);
	}

	// 导航--深色背景下清除导航高亮色与底部边线色
	if (theme.topicStyle === 'dark') {
		document.documentElement.style.setProperty('--mainHeader-light-color', '');
		if (theme.navigationBgColor === theme.asideBgColor) {
			themeParentNode.setAttribute('ui-theme', `${theme.topicStyle}-${theme.topicType}-block`);
		}
	}
	// 导航--填充导航色
	document.documentElement.style.setProperty('--mainHeader-bg-color', theme.navigationBgColor || 'var(--primary)');
	document.documentElement.style.setProperty('--mainHeader-other-color', theme.navigationBgColor || 'var(--primary)');
	// 导航--填充浅色风格导航高亮色
	document.documentElement.style.setProperty('--mainHeader-light-color', theme.navigationLightColor || '');

	// 导航--分段背景
	document.documentElement.style.setProperty('--mainHeader-left-top-bg-color', theme.navigationLeftBgColor || 'transparent');
	document.documentElement.style.setProperty('--mainHeader-left-top-bg-img', theme.navLeftBackgroundImg ? `url(${dealImageUrl(theme.navLeftBackgroundImg)})` : "none");
	document.documentElement.style.setProperty('--mainHeader-main-nav-bg-color', theme.navigationMediBgColor || 'transparent');
	document.documentElement.style.setProperty('--mainHeader-main-nav-bg-img', theme.navMediBackgroundImg ? `url(${dealImageUrl(theme.navMediBackgroundImg)})` : "none");
	document.documentElement.style.setProperty('--mainHeader-tool-menu-bg-color', theme.navigationRightBgColor || 'transparent');
	document.documentElement.style.setProperty('--mainHeader-tool-menu-bg-img', theme.navRightBackgroundImg ? `url(${dealImageUrl(theme.navRightBackgroundImg)})` : "none");

	//公共--主按钮色
	if (theme.primaryColor) {
		document.documentElement.style.setProperty('--primary', theme.primaryColor);
	}
	// 公共--气泡色
	if (theme.bubbleColor) {
		document.documentElement.style.setProperty('--bubble-color', theme.bubbleColor);
	}

	// 侧边菜单--背景色
	document.documentElement.style.setProperty('--mainAside-bc', theme.asideBgColor || 'var(--base-white)');
	// 侧边菜单--右边线色
	document.documentElement.style.setProperty('--mainAside-border-color', theme.asideRightBoderColor || '');
	// 侧边菜单--菜单默认色
	document.documentElement.style.setProperty('--mainAside-fc-color', theme.asideMenuColor || '');
	document.documentElement.style.setProperty('--mainAside-icon-fc-color', theme.asideMenuColor || '#999999');
	// 侧边菜单--菜单active、hover高亮色
	document.documentElement.style.setProperty('--mainAside-fc-light-color', theme.asideMenuHoverColor || 'var(--primary)');

	//快捷搜索栏
	document.documentElement.style.setProperty('--mainSearch-location', String(theme.searchShowType) === SearchShowType.EXPAND ? (searchLocationMap[String(theme.searchLocation)] || 'right') : 'right');
	document.documentElement.style.setProperty('--mainSearch-bg-color', theme.searchBgColor || (theme?.topicStyle === 'light' ? 'var(--mainHeader-light-color)' : 'rgba(0,0,0,.1)'));
	window.TEAMS.theme.themeType === "norm" && document.documentElement.style.setProperty('--mainHeader-search-fc', theme.searchFontColor || 'var(--base-white)')
	document.documentElement.style.setProperty('--mainSearch-border-color', theme.searchBoxColor || 'transparent');
	headerMenuStore.changeSearchShowType(theme?.searchShowType || SearchShowType.FLOAT)

	//客户端工具栏
	document.documentElement.style.setProperty('--mainTool-bg-color', theme.toolBgColor || theme.navigationBgColor || 'var(--primary)');
	document.documentElement.style.setProperty('--mainTool-bg-img', `url(${dealImageUrl(theme.toolBgImg)})`);
	if (theme.toolIcoColor === undefined || Number(theme.toolIcoColor) === 0) {	//工具栏风格 深色
		document.documentElement.style.setProperty('--mainTool-icon-color', 'var(--base-white)');
		document.documentElement.style.setProperty('--mainTool-icon-hover-color', 'var(--main-fc)');
		document.documentElement.style.setProperty('--mainTool-search-bg-color', 'rgba(0,0,0,.1)');
		document.documentElement.style.setProperty('--mainTool-border-color', 'transparent');
	} else {	//工具栏风格 浅色
		document.documentElement.style.setProperty('--mainTool-icon-color', 'var(--main-fc)');
		document.documentElement.style.setProperty('--mainTool-icon-hover-color', 'var(--main-fc)');
		document.documentElement.style.setProperty('--mainTool-search-bg-color', 'var(--mainHeader-bg-color)');
		document.documentElement.style.setProperty('--mainTool-border-color', 'var(--border-color)');
	}

	headerMenuStore.changeToolIcoStyle(	//图标显示方式
		Number(theme.topicLayout) === 2 ?
			(!theme.toolIcoStyle && theme.toolIcoStyle !== IconShowType.SOLID ? IconShowType.LINEAR : theme.toolIcoStyle) :
			(!theme.navIconType && theme.navIconType !== IconShowType.SOLID ? IconShowType.LINEAR : Number(theme.navIconType))
	);

	//客户端主题需要切换导航方式
	if (theme?.topicStyle === 'client') {
		mainStore.changeLayout(clientTypeLayoutModeMap[theme?.topicLayout || 0] as LayoutModes, true)
	}

	//导航色与侧边背景色相同时添加分割线
	const navAsideColorSame = !theme.navBackgroundImg && String(theme.navigationBgColor).toLocaleLowerCase() === String(theme.asideBgColor).toLocaleLowerCase();
	navAsideColorSame && themeParentNode.setAttribute("ui-theme-mode", "nav-aside-split");

	if (theme.topicType === "teams") {	//团队自定义主题覆盖

		// 导航--背景图片
		document.documentElement.style.setProperty('--mainHeader-bg-img', theme.navBackgroundImg ? `url(${dealImageUrl(theme.navBackgroundImg)})` : "none");
		// 导航--菜单字体
		document.documentElement.style.setProperty('--mainHeader-menu-ff', theme.navMenuFontType || "inherit");
		// 导航--菜单字号
		document.documentElement.style.setProperty('--mainHeader-menu-fs', theme.navMenuFontSize ? `${theme.navMenuFontSize}px` : 'var(--font-size-14)');
		// 导航--菜单字体颜色
		document.documentElement.style.setProperty('--mainHeader-menu-fc', theme.navMenuFontColor || (theme?.topicStyle === 'light' ? '#111111' : '#ffffff'));

		const navMenuDisplayType = theme.navMenuDisplayType === undefined ? 0 : theme.navMenuDisplayType;
		console.log([0, 2].indexOf(navMenuDisplayType) !== -1 ? "inline-block" : "none")
		// 导航--菜单图标是否显示
		document.documentElement.style.setProperty('--mainHeader-menu-icon-display', [0, 1].indexOf(Number(navMenuDisplayType)) !== -1 ? "inline-block" : "none");
		// 导航--菜单文字是否显示
		document.documentElement.style.setProperty('--mainHeader-menu-text-display', [0, 2].indexOf(Number(navMenuDisplayType)) !== -1 ? "inline-block" : "none");

		// 导航--填充浅色风格导航高亮色
		document.documentElement.style.setProperty('--mainHeader-light-color', theme.navOptMenuColor);
		document.documentElement.style.setProperty('--mainHeader-light-border-color', theme.navBorderColor);
		// 导航--logo显示位置
		headerMenuStore.changeLogoLocal(theme.logoLocal === undefined ? (isPrivateEnv() ? 1 : 0) : Number(theme.logoLocal));
		// 导航--应用图标显示方式
		headerMenuStore.changeNavIconType(Number(theme.navIconType) || 0);
		// 导航--应用图标与文字是否显示
		headerMenuStore.changeNavMenuDisplayType(Number(theme.navMenuDisplayType) || 0);

		// 侧边菜单--背景色
		document.documentElement.style.setProperty('--mainAside-bc', theme.asideBgColor || 'var(--base-white)');
		// 侧边菜单--字体
		document.documentElement.style.setProperty('--mainAside-ff', theme.sideMenuFontType);
		// 侧边菜单--字号
		document.documentElement.style.setProperty('--mainAside-fs', theme.sideMenuFontSize ? `${theme.sideMenuFontSize}px` : 'var(--font-size-14)');
		// 侧边菜单--菜单文字默认色
		document.documentElement.style.setProperty('--mainAside-fc-color', theme.asideMenuColor);
		document.documentElement.style.setProperty('--mainAside-icon-fc-color', theme.asideMenuColor || '#999999');

		// 侧边菜单--右边线色
		document.documentElement.style.setProperty('--mainAside-border-color', theme.asideRightBoderColor);
		// 侧边菜单--菜单文字高亮色
		document.documentElement.style.setProperty('--mainAside-fc-light-color', theme.asideMenuHoverColor);
		// 侧边菜单--菜单背景高亮色
		document.documentElement.style.setProperty('--mainAside-menu-active-bg', theme.sideOptMenuColor);
		// 侧边菜单--菜单左边框高亮色
		document.documentElement.style.setProperty('--mainAside-menu-active-border', theme.sideMenuLeftColor);

	} else {	//非团队自定义菜单 设置新增主题字段为默认值

		// 侧边菜单--字体
		document.documentElement.style.setProperty('--mainAside-ff', "inherit");
		// 侧边菜单--字号
		document.documentElement.style.setProperty('--mainAside-fs', `var(--font-size-14)`);
		// 侧边菜单--菜单背景高亮色
		if (theme.screenShot === 'glyh' || theme.screenShot === 'dfyy') { //高冷烟灰和东方夜韵特殊处理
			document.documentElement.style.setProperty('--mainAside-menu-active-bg', theme.sideOptMenuColor);
		} else {
			document.documentElement.style.setProperty('--mainAside-menu-active-bg', "rgba(0,0,0,.065)");
		}
		if (theme.screenShot === 'glyh' || theme.screenShot === 'dfyy') {//高冷烟灰特殊处理
			document.documentElement.style.setProperty('--mainAside-menu-active-border', theme.sideMenuLeftColor);
		} else {
			// 侧边菜单--菜单左边框高亮色
			document.documentElement.style.setProperty('--mainAside-menu-active-border', "var(--mainAside-fc-light-color)");
		}

		// 导航--背景图片
		document.documentElement.style.setProperty('--mainHeader-bg-img', "none");
		// 导航--菜单字号
		document.documentElement.style.setProperty('--mainHeader-menu-fs', `var(--font-size-14)`);
		//菜单文字颜色
		document.documentElement.style.setProperty('--mainHeader-menu-fc', theme.topicStyle === 'light' ? 'var(--main-fc)' : 'var(--base-white)');
		// 导航--菜单图标是否显示
		document.documentElement.style.setProperty('--mainHeader-menu-icon-display', "inline-block");
		// 导航--菜单文字是否显示
		document.documentElement.style.setProperty('--mainHeader-menu-text-display', "inline-block");
		// 导航--logo显示位置
		headerMenuStore.changeLogoLocal(isPrivateEnv() ? 1 : 0);
		// 导航--应用图标显示方式
		headerMenuStore.changeNavIconType(IconShowType.LINEAR);
		headerMenuStore.changeToolIcoStyle(IconShowType.LINEAR);
		// 导航--应用图标与文字是否显示
		headerMenuStore.changeNavMenuDisplayType(0);

		const themeType = theme.topicType || theme.type;
		if (themeType === "custom") {	//个人自定义可以设置菜单背景高亮色和logo显示位置
			// 侧边菜单--菜单背景高亮色
			document.documentElement.style.setProperty('--mainAside-menu-active-bg', theme.sideOptMenuColor || "#00000012");
			// 导航--logo显示位置
			headerMenuStore.changeLogoLocal(theme.logoLocal === undefined ? (isPrivateEnv() ? 1 : 0) : Number(theme.logoLocal));

			// 导航--填充浅色风格导航高亮色
			document.documentElement.style.setProperty('--mainHeader-light-color', theme.navigationLightColor);
			document.documentElement.style.setProperty('--mainHeader-light-border-color', theme.navigationLightColor);
		} else if (theme.topicStyle === 'light') { //非自定义切是浅色导航时，navigationLightColor不生效
			document.documentElement.style.setProperty('--mainHeader-light-border-color', theme.navigationLightColor);
		}
	}

	//外部联系人主题导航背景图片处理
	if (window?.TEAMS?.currentUser?.type === "external" && theme?.topicSource === "external") {
		document.documentElement.style.setProperty('--mainHeader-bg-img', `url(${mainStore.layoutMode === "h" ? `${externalThemeBgH}` : `${externalThemeBgV}`})`);
	}

	if (window?.ecodeCustomLogoLocal) {
		headerMenuStore.changeLogoLocal(Number(window?.ecodeCustomLogoLocal));
	}
}
export function cloneObj(Obj: any) {
	let buf: any;
	if (Obj instanceof Array) {
		buf = [];  //创建一个空的数组
		let i = Obj.length;
		while (i--) {
			buf[i] = cloneObj(Obj[i]);
		}
		return buf;
	} else if (Obj instanceof Object) {
		buf = {};  //创建一个空对象
		for (let k in Obj) {  //为这个对象添加新的属性
			buf[k] = cloneObj(Obj[k]);
		}
		return buf;
	} else {
		return Obj;
	}
}
export function doResize() {
	const timer = setTimeout(function () {
		//@ts-ignore
		if (document.createEvent) {
			var event = document.createEvent("HTMLEvents");
			event.initEvent("resize", true, true);
			window.dispatchEvent(event);
			//@ts-ignore
		} else if (document.createEventObject) {
			window.fireEvent("onresize");
		}
		clearTimeout(timer);
	}, 100);
}
export function setNav(direction?: LayoutModes) {
	const dir = direction || mainStore.layoutMode;
	const layoutNode: any = document.querySelector(`.${mainClsPrefix}-layout`);
	if (!navNeedShow()) {
		document.documentElement.style.setProperty('--mainHeader-hoz-height', '0px');
	} else {
		layoutNode.className = `${mainClsPrefix}-layout ${inPCClient() ? `${mainClsPrefix}-client` : ''} ${mainClsPrefix}-layout-${dir} ${dir === "mixed" ? `${mainClsPrefix}-layout-v` : ''}`;
		document.body.setAttribute('layout', dir);
		document.documentElement.style.setProperty('--mainHeader-hoz-height', dir === 'v' || dir === 'mixed' ? '0px' : '50px');

		//外部联系人主题导航背景图片处理
		if (window?.TEAMS?.currentUser?.type === "external" && window.TEAMS?.theme?.topicSource === "external") {
			document.documentElement.style.setProperty('--mainHeader-bg-img', `url(${dir === "h" ? `${externalThemeBgH}` : `${externalThemeBgV}`})`);
		}
	}
	setDialogConfig();
}

//他人空间各个模块新老版本
export const OtherSpaceModuleNewVersionMap: { [module: string]: boolean } = {
	'task': true,	//任务
	'mainline': true,	//项目
	'calendar': false,	//日程
	'workflow': true,	//审批
	'document': true,	//文档
	'blog': true,	//日报
	'workreport': true,	//计划报告
	'customer': true,	//客户
	'saleChance': true,	//商机
	'contact': true,	//联系人
	'contract': true,	//合同
	'orderform': true,	//订单
	'capital': true,	//资金
	'quote': true,	//报价
	'price': true,	//价格
	'production': true,	//产品
	'competitor': true,	//对手
	'saleTarget': true,	//okr
}

//各个模块首页
export const modulesHomes = ['/task', '/project', '/calendar', '/workflow', '/doc', '/blog', '/plan', '/crm/customer', '/crm/salechance', '/crm/contact', '/crm/contract', '/crm/orderform', '/crm/capital', '/crm/quote', '/crm/price', '/crm/production', '/crm/competitor',]

export const RoutePathControlByOther = (item: any, userId: string,) => {//下属空间菜单控制
	const key = item.module as string;
	if (!key || !userId) return item;
	let params = window.location.search;
	if (!params && window.TEAMS?.eworkspace?.user) {
		params = `?subEmployeeId=${window.TEAMS?.eworkspace?.user.id}`
	}
	const routePool: any = {
		//新版他人空间菜单链接
		'task': `/task/list/eworkspace_${userId}/mine${params}`,	//任务
		'mainline': `/project/list/eworkspace_${userId}/mine${params}`,	//项目
		'calendar': `/calendar/eworkspace_${userId}${params}`,	//日程
		'workflow': `/workflow/list/eworkspace_${userId}/mine${params}`,	//审批
		'document': `/doc/knowledge/created/eworkspace_${userId}${params}`,	//文档
		'blog': `/blog/myblog/workspace/eworkspace_${userId}${params}`,	//日报
		'workreport': `/plan/eworkspace_${userId}/his${params}`,	//计划报告
		'customer': `/crm/customer/eworkspace_${userId}/customerList/mine${params}`,	//客户
		'saleChance': `/crm/salechance/eworkspace_${userId}/list/mine${params}`,	//商机
		'contact': `/crm/contact/eworkspace_${userId}/personal${params}`,	//联系人
		'contract': `/crm/contract/eworkspace_${userId}/list/mine${params}`,	//合同
		'orderform': `/crm/orderform/eworkspace_${userId}/list/mine${params}`,	//订单
		'capital': `/crm/capital/eworkspace_${userId}/list/mine${params}`,	//资金
		'quote': `/crm/quote/eworkspace_${userId}/list/mine${params}`,	//报价
		'price': `/crm/price/eworkspace_${userId}/list/mine${params}`,	//价格
		'production': `/crm/production/eworkspace_${userId}/list/mine${params}`,	//产品
		'competitor': `/crm/competitor/eworkspace_${userId}/list/all${params}`,	//对手

		'saleTarget': `/goal/eworkspace_${userId}${params}`,	//okr
	}
	const routePoolOld: any = {
		//老版他人空间菜单链接
		'task': `/task/list/${userId}/mine`,
		'mainline': `/project/list/${userId}/mine`,
		'calendar': `/calendar/${userId}`,
		'workflow': `/workflow/list/${userId}/mine`,
		'document': `/doc/knowledge/created/${userId}`,
		'blog': `/blog/myblog/workspace/${userId}`,
		'workreport': `/plan/list/${userId}/mine`,
		'customer': `/crm/customer/${userId}/customerList/mine`,
		'saleChance': `/crm/salechance/${userId}/list/mine`,
		'contact': `/crm/contact/${userId}/personal`,
		'contract': `/crm/contract/${userId}/list/mine`,
		'orderform': `/crm/orderform/${userId}/list/mine`,
		'capital': `/crm/capital/${userId}/list/mine`,
		'quote': `/crm/quote/${userId}/list/mine`,
		'price': `/crm/price/${userId}/list/mine`,
		'production': `/crm/production/${userId}/list/mine`,
		'competitor': `/crm/competitor/${userId}/list/all`,

		'saleTarget': `/goal`,	//okr
	}
	// console.log(`${item.module}----------${routePool[key]}`)
	if (routePool[key] || routePoolOld[key]) {
		return {
			...item,
			path: OtherSpaceModuleNewVersionMap[key] ? routePool[key] : routePoolOld[key]
		}
	}
	return item;

}
export const controlCountryCodeFc = (arra: any) => {
	let data: any = [];
	arra.forEach((element: any) => {
		Object.values(element).forEach((it: any) => {
			it.forEach((current: any) => {
				const info = current.replace(/\s*/g, "").split('+');
				const label = info[0];
				const id = '+' + info[1];
				const type = Object.keys(element)[0];
				data.push({ label, id, type })
			});
		});
	});
	return data;
}

export function getElementTop(element: any) {
	if (!element)
		return 0;
	let actualTop = element.offsetTop;    //这是获取元素距父元素顶部的距离
	let current = element.offsetParent;   //这是获取父元素
	while (current !== null) {      //当它上面有元素时就继续执行
		actualTop += current.offsetTop;   //这是获取父元素距它的父元素顶部的距离累加起来
		current = current.offsetParent;　　//继续找父元素
	}
	return actualTop;
}

export const createTitle = () => {
	return {
		"customer": getLabel('61784', '新建客户'),
		"contact": getLabel('61786', '新建联系人'),
		"clue": getLabel('61790', '新建线索')
	}
}


export function setDialogConfig() {
	// const hd = window.TEAMS?.theme?.hd || 1;
	const dir = mainStore.layoutMode;
	let top: number = 50;
	if (dir === 'v') {
		// top = inPCClient() ? 30 : 0;
		top = 0;
	}
	if (!navNeedShow() || window.ecode_hidden_LayoutNav) {
		top = 0;
	}
	if (window.TEAMS?.eworkspace) {
		top = 0;
	}
	Dialog.dialogConfig = {
		top: top,
		placement: 'right'
	};
}
export function inMacClient() {
	return /(?=.*weapp-pc)(?=.*Macintosh)/i.test(navigator.userAgent);
}
export function inWinClient() {
	return /(?=.*weapp-pc)(?=.*Windows)/i.test(navigator.userAgent);
}

// export function hasParent(target: any, classname = '') {
// 	if ('BODY' !== target.parentNode.nodeName) {
// 		const parentNode = target.parentNode;
// 		const cls = parentNode.className.split(' ');
// 		if (cls.includes(classname)) {
// 			return true;
// 		} else {
// 			return hasParent(target.parentNode, classname)
// 		}
// 	}
// 	else return false;
// }


export function canShowInviteDialog() {
	const TEAMS = window.TEAMS!;
	if (isThirdAppUa()) {
		return false;
	}
	return TEAMS?.currentUser.activeDate
		&& !window.inFetionClient
		&& !((typeof (TEAMS.currentTenant.tenantType) != "undefined" && TEAMS.currentTenant.tenantType === "enterpriseWeChat")
			|| TEAMS.currentTenant.status === "normal" || TEAMS.currentTenant.status === "outPayUserInweek"
			|| TEAMS.currentTenant.status === "outPayUserOutweek" || TEAMS.currentTenant.status === "outPayRoom")
		&& TEAMS.currentTenant.usedLicense <= 3
		&& (TEAMS.currentUser.admin || (!TEAMS.currentUser.admin && !TEAMS.currentTenant.inviteForbid))
}



export function navNeedShow() {
	let flag: boolean = isShowNavigationByUrl();

	// if (inWxWork()) {
	// 	// 企业微信配置ET作为整体打开的免登应用
	// 	const wxNavShow = sessionStorage.getItem('wxNavShow');
	// 	if (!wxNavShow) {
	// 		flag = false;
	// 	} else {
	// 		flag = true;
	// 	}
	// }

	// // 通过输入账号密码登录进来的用户,即使在第三方中也需要显示
	// if (!window.TEAMS?.loginChannel) {
	// 	flag = true;
	// }

	// if (isThirdAppUa() && !inWxWork()) {
	// 	flag = false;
	// }
	if (window.TEAMS?.loginAccountInfo?.eBridge_nav === '0') {
		flag = false;
	}
	return flag;
}

export function needShowTenant() {
	let flag = true;
	if (inWxWork()) {
		if (window.TEAMS?.loginChannel) {//企业微信输入账号密码进入
			flag = false;
		}

	} else {
		if (isThirdAppUa()) {
			flag = false;
		}
	}
	// 集成登录
	// if ((window.TEAMS?.loginChannel || '').indexOf!('intunifyauth') !== -1 || (window.TEAMS?.currentUser?.loginChannel || '').indexOf!('intunifyauth') !== -1) {
	// 	flag = false;
	// }
	// 禁止切换团队时
	if (window.TEAMS?.loginAccountInfo?.forbidChangeTenant) {
		flag = false;
	}
	return flag
}

export function isIntunifyauthLogin() {
	return (window.TEAMS?.loginChannel || '').indexOf!('intunifyauth') !== -1 || (window.TEAMS?.currentUser?.loginChannel || '').indexOf!('intunifyauth') !== -1;
}

export function needShowIvite() {
	let flag = true;
	if (inWxWork()) {
		if (window.TEAMS?.loginChannel) {//企业微信输入账号密码进入
			flag = false;
		}
	} else {
		if (isThirdAppUa()) {
			flag = false;
		}
	}
	return flag
}

export function needShowLogout() {
	let flag = true;

	if (inWxWork()) {
		if (window.TEAMS?.loginChannel) {//非企业微信输入账号密码进入
			flag = false;
		}

	} else {
		if (isThirdAppUa()) {
			flag = false;
		}
	}
	//特殊情况：企业微信免登如果显示了导航，需要隐藏退出登录
	if (sessionStorage.getItem('wxNavShow')) {
		flag = false;
	}

	return flag;
}

export function needShowEm() {
	let flag = false;
	//lisence
	if (window.TEAMS?.isDisplayModule?.('im') || window.TEAMS?.isDisplayModule?.('emmsg')) {
		flag = true;
	}
	//调试模式
	if (getQueryString('wea_link_keep_noem') && getQueryString('wea_link_keep_noem') === '1') {
		flag = false;
	}

	if (window.TEAMS?.loginAccountInfo?.eBridge_em === '0') {
		flag = false;
	}
	//皮肤预览模式
	if (window.inThemePreviewMode) {
		flag = false;
	}

	//他人空间不显示em
	if (window.TEAMS?.eworkspace) {
		flag = false;
	}

	//外部联系人不显示 & ecode控制不加载em
	if (window.TEAMS?.currentUser?.type === 'external') {
		flag = false;
	}
	if (window.ecode_em_disabled) {
		flag = false;
	}

	//云端环境租户付费状态显示判断
	if (isProductEnv()) {
		if (!['prepaid', 'outPayUserInweek', 'outPayUserOutweek', 'outPayRoom', 'normal'].includes(window.TEAMS?.currentTenant?.status)) {
			flag = false
		}
	}

	return flag;
}

export function canShowWxIntro() {
	if (isThirdAppUa()) {
		return false;
	}
	const TEAMS = window.TEAMS!;
	//弹出企业微信弹框
	const introductionTime = '2020122320';
	const activeDate = TEAMS.currentUser?.activeDate ? dayjs(TEAMS.currentUser?.activeDate).format("YYYYMMDDHH") : '0';	//用户激活时间
	let moduleName = window.location.pathname.replace(layoutPublicUrl, '').split('/')[1];
	if (moduleName !== 'portal') {
		return false;
	}

	if (introductionTime > activeDate) {	//激活时间大于提示时间，返回
		return false;
	}
	if (TEAMS?.currentTenant && TEAMS?.currentTenant?.tenantType) {
		return false;
	}
	if (TEAMS?.deploy === 'private') {
		return false;
	}
	const wxworkShow = (TEAMS?.userConfig && TEAMS?.userConfig['wxworkintro.needShow']) || 'show';
	if (wxworkShow !== 'hide' && TEAMS.currentUser.admin && !window.inFetionClient) {
		return true;
	}
	return false;
}
export function langIsZh() {
	return window.TEAMS.locale && (window.TEAMS.locale.lang === 'zh_CN' || window.TEAMS.locale.lang === 'zh_TW');
}
export function isIpHost() {
	const host = window.location.hostname;
	const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
	return reg.test(host);
}

const findStr = (str1 = '', str2 = '') => {
	let shorter, longer;
	if (str1?.length > str2?.length) {
		shorter = str2;
		longer = str1
	} else {
		shorter = str1;
		longer = str2;
	}
	for (let subLength = shorter?.length; subLength > 0; subLength--) {
		for (let i = 0; i + subLength <= shorter.length; i++) {
			let subString = shorter.substring(i, i + subLength);
			if (longer.indexOf(subString) >= 0) {
				if (subString.charAt(subString.length - 1) == "/") {
					subString = subString.substr(0, subString.length - 1);
				}
				return subString;
			}
		}
	}
}
export const hasSameLastWord = (str: string, key: string) => {
	return str.substr(-1)
}
export const getMaxLengthSameStr = (arr: any, str = '') => {//从数组中获取公共最长子串
	let maxLength = 0;
	let data = undefined as any;
	const exactData = arr.find((item: any) => item.path === str || item.url === str);
	if (exactData) { return exactData };
	let sameStr = '';
	str = str.split('?')[0];
	const isStrHasSlash = str.substr(-1) == '/';

	if (isStrHasSlash) {//当前url路由添加'/'后缀
		str = str + '/';
	}

	const originUrlArray = (str || '').split('/');
	arr.forEach((item: any) => {
		let path = ((item.module === 'freeUrl' ? item.url : item.path) || '').split('?')[0];
		const isPathHasSlash = path.substr(-1) == '/';
		if (path && !isPathHasSlash) {//后台返回数据添加'/'
			path = path + '/';
		}
		const maxSameStr = findStr(path || '', str || '') || '';
		const minStrLength = str.split('/')[1]?.length;///解决cus/position问题
		const matchFromStart = path && str.indexOf(path) === 0 && maxSameStr?.length >= minStrLength;//从初始位置就开始匹配且大于一单词地段
		const splitArray = maxSameStr.split('/');
		const originPathArray = path.split('/');
		const lastExctWord = splitArray[splitArray.length - 1];//单词全匹配控制，单词拆分后匹配不进入逻辑
		if (matchFromStart && maxSameStr && maxSameStr.length >= maxLength && originPathArray.includes(lastExctWord) && originUrlArray.includes(lastExctWord)) {
			if (maxSameStr.length === maxLength) { //等于时只有默认系统模块才会替换
				if (item?.id && item?.id?.length < 4) {
					if (data?.path === maxSameStr || data?.url === maxSameStr) {//以根路由匹配优先，与带二级的重复的优先取层级少的
						return
					}
					data = item;
					maxLength = maxSameStr.length;
					sameStr = maxSameStr;
				}
			}
			else {
				data = item;
				maxLength = maxSameStr.length;
				sameStr = maxSameStr;
			}
		}
	})
	if (sameStr === '/ebdapp/view' || sameStr === '/cusapp' || (hiddenNavigationList.includes(str))) {//eb 不全匹配id的话返回空节点
		return null;
	}
	return maxLength ? data : null;
}

export function getBrowserTitle(appMenus?: any, themeConfig?: any) {
	if (!appMenus) {
		appMenus = toJS(headerMenuStore.allAppMenus);
	}
	const tenantName = window.TEAMS?.currentTenant?.tenantName;
	let moduleName: any = '';
	let pathname = window.location.pathname.replace(layoutPublicUrl, '');
	if (pathname === '/') {
		moduleName = window.weappTenantEnv?.urlTitle || 'eteams';
	} else if (pathname.indexOf('/portal') !== -1) {
		moduleName = getLabel('62505', '门户')
	} else if (pathname.indexOf('/profile') !== -1) {//个人设置
		moduleName = getLabel('62305', '个人设置')
	} else if (pathname.indexOf('/hrm/orgsetting') !== -1) {//组织架构
		moduleName = getLabel('158130', '组织架构')
	} else if (pathname.indexOf('/hrm/addressbook') !== -1) {//通讯录
		moduleName = getLabel('14801', "通讯录")
	} else if (pathname.indexOf('/cloudstore') !== -1) {//云商店
		moduleName = getLabel('109935', "云商店")
	} else if (pathname.indexOf('/esearch') !== -1) {//全文检索
		moduleName = getLabel('67238', "全文检索")
	}
	else {
		let appList = [] as any;
		appMenus && appMenus.forEach((colum: any) => {
			colum.forEach((group: any) => {
				group.menus && group.menus.forEach((menu: any) => {
					appList.push(menu);
				});
			});
		});
		const currentAppInfo = getMaxLengthSameStr(appList, pathname);
		if (currentAppInfo) {
			//外部链接
			// if (currentAppInfo.module === 'freeUrl') {
			// 	if (currentAppInfo.path.indexOf('/customurl') !== -1) {
			// 		moduleName = currentAppInfo.shortname || currentAppInfo.menuname
			// 	}
			// 	//内部链接不处理，老et一样当做内部模块判断
			// } else {
			// 	moduleName = currentAppInfo.shortname || currentAppInfo.menuname
			// }
			moduleName = currentAppInfo.shortname || currentAppInfo.menuname || ''
		}
	}
	// 技术文档特别处理
	if (pathname.indexOf('/techdoc/repository') !== -1) {//技术文档
		moduleName = getLabel('183339', "技术文档")
	}
	const themeTitle = (themeConfig || window.TEAMS?.theme)?.titleName;

	if (window.layout_ecode_hide_module_tenant_name) {
		return `${themeTitle ? themeTitle : tenantName}`;
	}
	if (window.layout_ecode_title_hide_module) {
		return `${tenantName}${themeTitle ? ' - ' + themeTitle : ''}`;
	}
	return `${moduleName ? moduleName + ' - ' : ''}${tenantName}${themeTitle ? ' - ' + themeTitle : ''}`;
}

export function setBrowserTitle(appMenus?: any) {
	setTitle({
		title: window.weappLayout?.layoutTitle || getBrowserTitle(appMenus)
	});
}
export const getQueryString = (name: any, str?: any) => {
	let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	if (!str) {
		str = window.location.search.substr(1);
	}
	let r = str.match(reg);
	if (r != null) return unescape(decodeURIComponent(r[2])); return null;
}


//eb菜单参数转链接
export const getUrlFromEBConfig = (config: any) => {
	// return window.weappEbdcoms?.getPageViewUrl?.(config, false);

	let path: string = config.page?.pageType === "LINK" ? config.page?.pageId : `/ebdapp/view/${config.page?.appid}/search/${config.page?.pageId}`;

	//如果eb应用有对应的菜单id
	if (config.menuId) {
		path = `${path}-${config.menuId}`;
	}

	const params: string = config.params.map((item: any) => {
		const key: string = item.nameType === "FORMFIELDS" ?
			`field_${item.name.id}` : 	//表单字段
			item.name;	//固定字段
		return `${key}=${item.value}`
	}).join("&");
	return path + (params ? `?${params}` : '')
}

export const treeToList = (array: any = [], currentOrg: any) => {//树形数据转list
	return array.reduce((arr: any, curItem: any) => {
		return arr.concat([curItem], treeToList(curItem?.children, currentOrg))
	}, [])
}


//获取当前页面window.location.origin替换
export function getLocationOrigin() {
	return window.location.protocol + '//' + window.location.host;
}
export const clearCookieByName = function (name: string) {
	let host = window.location.hostname;
	const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
	//清理当前域
	document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

	//ip地址访问
	if (!reg.test(host)) {
		host = '.' + host;
		for (var i = 0; i < host.length; i++) {
			if (host[i] === '.') {
				let domain = host.substr(i + 1);
				document.cookie = name + "=;domain=" + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
				document.cookie = name + "=;domain=." + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			}
		}
	}
}

//帮助中心隐藏
export function hideHelp() {
	return window.TEAMS?.globalConfig?.helpDisabled && window.TEAMS?.globalConfig?.helpDisabled === '1';
}

export const isIE = () => {
	return !!window.ActiveXObject || "ActiveXObject" in window
}

export const opennewTab = (path: any) => {
	if (isIE()) {
		const a = document.createElement("a");
		a.style.display = 'none';
		a.setAttribute('target', '_blank');
		a.href = path;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	} else {
		window.open(path);
	}
}

export function isIframeOpen() {
	return window.self?.frameElement?.tagName == "IFRAME";
}

/*
* 是否为桌面客户端 -- 用于向客户端发送log通知
*/
export function inPCClient() {
	if (isPreview()) {	//预览模式下
		return isPreviewClient();
	} else {
		return /weapp-pc/i.test(window.navigator.userAgent);
	}
}

/*
* 判断终端类型
* pc，app-pc，app-and，app-ios
*/
export function getTerminalType() {
	if (window.weappUtils?.ua?.device === 'PC') {
		//pc客户端
		if (isElectron()) {
			return 'app-pc'
		} else {
			return 'pc'
		}
	} else {
		if (window.weappUtils?.ua?.os === 'Android') {
			return 'app-and'
		} else {
			return 'app-ios'
		}
	}
}

export function isClientWindows() {
	return inPCClient() && window.weappUtils?.ua?.os === "Windows";
}

export function isClientMac() {
	return inPCClient() && (window.weappUtils?.ua?.os === "Mac OS" || window.weappUtils?.ua?.os === "Mac");
}
//新版pc客户端判断方法
function isElectron() {
	const userAgent = navigator.userAgent.toLowerCase();
	return userAgent.indexOf('electron') > 0 && userAgent.indexOf('weapp-pc') > 0;
}
function isWindows() {
	const userAgent = navigator.userAgent.toLowerCase();
	return /windows nt/.test(userAgent);
}
export function isFrameLess(isFullscreen?: boolean) {	//是否新版无边框客户端
	if (isIframeOpen()) {
		return false;
	}
	return !!window.__ET_CLIENT_NO_TITLE
}
export function lowerCase(str: string = '') {
	return str.toLocaleLowerCase();
}

//是否预览模式
export function isPreview() {
	return isPreviewToolMenu() || isPreviewTheme();
}

//是否主题预览模式
export function isPreviewTheme() {
	try {
		return !!window.parent?.previewThemeData;
	} catch (e) {
		return false;
	}
}

//是否主题预览模式
export function isPreviewPersonMenu() {
	try {
		return !!window.parent?.previewPersonMenuData;
	} catch (e) {
		return false;
	}
}

//是否导航工具菜单预览模式
export function isPreviewToolMenu() {
	let isPreview = false;
	try {
		isPreview = !!window.parent?.previewData?.toolMenu;
	} catch (e) {

	}
	return isPreview;
}

export function getPreviewNavData() {
	let previewData = {} as any;
	try {
		previewData = window.parent?.previewData?.toolMenu;
	} catch (e) {

	}
	return previewData;
}

//是否预览客户端
export function isPreviewClient() {
	let isPreview = false;
	try {
		isPreview = window.parent?.previewData?.client;
	} catch (e) {

	}
	return isPreview;
}
export function isPreviewWeb() {
	let isPreview = false;
	try {
		isPreview = !window.parent?.previewData?.client;
	} catch (e) {

	}
	return isPreview;
}

//获取IconSelection组件的图标名称
export function getIconSelectionIconName(value: string, isSolid?: boolean) {
	return value ?
		`Icon-custom${"0".repeat(2 - String(value).length)}${value}${isSolid ? '' : '-o'}` :
		`Icon-custom01${isSolid ? '' : '-o'}`;
}
export function isWeaverOa() {
	return window.location.host.indexOf('e-cology.com') !== -1;
}

export function getAppMenuWidth() {
	const { navMenuDisplayType = 0 } = headerMenuStore!;
	let menuWidth: number = langIsZh() ? 98 : 125;
	switch (navMenuDisplayType) {
		case 0: //显示文字图标
			menuWidth = langIsZh() ? 98 : 125;
			break;
		case 1: //仅图标
			menuWidth = langIsZh() ? 50 : 50;
			break;
		case 2: //仅文字
			menuWidth = langIsZh() ? 74 : 101;
			break;
	}
	return menuWidth;
}

export function isFirefox() {//是否是火狐浏览器
	return navigator?.userAgent?.indexOf("Firefox") > 0
}
export function isExternal() {//是否是外部联系人
	return window.TEAMS?.currentUser?.type === 'external';
}

export function measureTextWidth(text: string = "", fontSize?: number) {
	const canvas = document.createElement("canvas");
	let context = canvas?.getContext?.("2d");
	if (context) {
		if (!fontSize) {
			fontSize = 14;
			switch (window.TEAMS.theme.fontSize) {
				case "small":
					fontSize = 14;
					break;
				case "medium":
					fontSize = 16;
					break;
				case "big":
					fontSize = 16;
					break;
			}
		}

		context.font = `${fontSize}px Arial`;
	}
	return Math.round(context?.measureText(text)?.width || getAppMenuWidth());
}

export const getLayoutModeConfig = () => {//主框架下菜单、插件、em等加载模式配置获取
	let urlParams = parse(window.location.search?.replace('?', '')) || {}; //获取url数据
	const keys = ['wea_link_keep_spmode', 'wea_link_keep_nolayoutnav', 'wea_link_keep_noem', 'wea_link_keep_nomodulemenu']
	const layoutModeConfig: any = {};
	keys.forEach((key: string) => {
		layoutModeConfig[key] = urlParams[key]
	})
	return layoutModeConfig;
}
export const isSpmodeByUrl = () => {//单页模式
	return getLayoutModeConfig().wea_link_keep_spmode === '1'
}
export const isShowNavigationByUrl = () => {//显示导航
	return !(isSpmodeByUrl() || getLayoutModeConfig().wea_link_keep_nolayoutnav === '1')
}
export const isShowAsideByUrl = () => {//显示消息
	return !(isSpmodeByUrl() || getLayoutModeConfig().wea_link_keep_nomodulemenu === '1')
}
export const isShowEMByUrl = () => {//显示侧边菜单
	return !(isSpmodeByUrl() || getLayoutModeConfig().wea_link_keep_noem === '1')
}
export function isExternalTest() {//是否是外部联系人
	if (window.TEAMS.runMode === 'txproduction' && window.TEAMS?.deploy === "public") return false;
	return window.TEAMS?.currentUser?.type === 'external';
}

export const isManagerTenant = () => {//判断是否是主管理团队
	return !!window.TEAMS?.managerTenant;
}

export function getFilePreviewUrl(fileId: string, type: string = 'imgs', noSecondPath?: boolean) {
	return `${noSecondPath ? '' : publicUrlapi}/api/file/preview?fileId=${fileId}&type=${type}`;
}

//文件权限改造兼容处理老数据
//url可能是静态资源（/static/**）、老数据（/api/file/noauth/**、/papi/file/noauth/**）
export function dealImageUrl(url: string, noSecondPath?: boolean) {
	if (!url) {
		return "";
	}
	if (url?.indexOf("/") === -1) {
		return getFilePreviewUrl(url, 'imgs', noSecondPath);
	}
	return url.replace('/papi/file/noauth/', '/papi/file/preview?type=imgs&fileId=')
		.replace('/api/file/noauth/', '/api/file/preview?type=imgs&fileId=');
}

export function isE10Self() {
	if (localStorage.getItem("_TEST_E10_")) {
		return true;
	}
	return window.location.host === 'www.e-cology.com.cn'
}

//应用过滤
export function filterApp(data: any) {

	if (window.localStorage.getItem("_TEST_shijingran_installed")) {
		window.TEAMS.globalConfig.project_shijingran_installed = '1'
	}

	//安装过事井然的不显示项目、任务
	if (window.TEAMS?.globalConfig?.project_shijingran_installed === '1') {
		return data.filter((item: any) => {
			console.log(item)
			return (
				item.module !== 'mainline'
				// && item.module !== 'task'
			)
		})
	}
	return data;
}
